import { env } from '@/env'

export const ENVIRONMENT = env.VITE_ENV

export const AZURE_AD_CLIENT_ID = env.VITE_AZURE_AD_CLIENT_ID
export const AZURE_AD_TENANT_ID = env.VITE_AZURE_AD_TENANT_ID
export const API_ACCESS_TOKEN_SCOPE = env.VITE_AZURE_API_SCOPE

export const CONTROL_CENTRE_API_DOMAIN: string =
  env.VITE_CONTROL_CENTRE_API_DOMAIN

export const CONTROL_CENTRE_V2_API_DOMAIN: string =
  env.VITE_CONTROL_CENTRE_V2_API_DOMAIN
